<form novalidate
      [formGroup]="idCardListDataForm"
      flex
      layout="row"
      layout-wrap
      layout-align="space-between center">
  <div flex
       layout="row"
       layout-wrap
       layout-align="space-between start">
    <mat-form-field flex="100"
                    class="margin-top-20">

      <input class="upload-trigger"
             matInput
             readonly
             formControlName="newFile"
             placeholder="{{(idCardImageType === IdCardImageTypes.ID_FRONT ? 'mi.idCardFront' : idCardImageType === IdCardImageTypes.ID_BACK ? 'mi.idCardBack' : 'mi.idCardSelfie') | translate }}"
             [value]="idCardListDataForm?.controls['newFile'].value.name || ''"
             #fileResult
             (click)="fileUpload.triggerUploadButton()"
             flex />
      <div matSuffix layout="row" class="actions-container">
        <button type="button"
                [disabled]="uploadInProgress || !selectedImageId || (['USER_DOCUMENT_WRITE'] | isUnauthorized | async)"
                matIconButton
                matTooltip="{{'identityDocuments.rotateAnticlockwiseActionTooltip' | translate }}"
                matTooltipPosition="above"
                (click)="rotateImage(selectedImageId, false)">
          <mat-icon>rotate_left</mat-icon>
        </button>
        <button type="button"
                [disabled]="uploadInProgress || !selectedImageId || (['USER_DOCUMENT_WRITE'] | isUnauthorized | async)"
                matIconButton
                matTooltip="{{'identityDocuments.rotateClockwiseActionTooltip' | translate }}"
                matTooltipPosition="above"
                (click)="rotateImage(selectedImageId, true)">
          <mat-icon>rotate_right</mat-icon>
        </button>
        <button type="button"
                [disabled]="uploadInProgress || !selectedImageId || (['USER_DOCUMENT_READ'] | isUnauthorized | async)"
                matIconButton
                matTooltip="{{'global.download' | translate }}"
                matTooltipPosition="above"
                (click)="downloadCurrentlySelectedImage(selectedImageId)">
           <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1">download_for_offline</span>
        </button>
        <itfg-file-upload [compact]="true"
                          [disabled]="uploadInProgress || (['USER_DOCUMENT_WRITE'] | isUnauthorized | async)"
                          #fileUpload
                          (fileSelected)="onFileSelected($event, idCardListDataForm?.controls['newFile'])"></itfg-file-upload>
        <button matIconButton
                [disabled]="uploadInProgress || !selectedImageId || (['USER_DOCUMENT_DELETE'] | isUnauthorized | async)"
                (click)="deleteCurrentlySelectedDocument()"
                matTooltip="{{ 'global.delete' | translate }}"
                matTooltipPosition="above">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      @if (idCardListDataForm.get('newFile').errors?.maxSize) {
      <mat-error [translate]="'forms.maxSize'"
                 [translateParams]="{value: maxFileSize}">
        Required field
      </mat-error>
      }
 
    </mat-form-field>
  </div>
</form>

@if (idCardListData?.length > 0) {
<form [formGroup]="form">
  <mat-selection-list #shoesList
                      [formControl]="selectedImageControl"
                      name="selectedImage"
                      [multiple]="false"
                      class="id-card-image-list">
    @for (document of idCardListData; track document) {
    <mat-list-option matTooltip="{{document.name}}"
                     matTooltipPosition="right"
                     [value]="document"
                     [class.selected-option]="selectedImageControl.value && selectedImageControl.value[0]?.id === document.id">
      <span class="title"
            matListItemTitle>{{document.name | shortenFileName: 30 }}</span>
      <span matListItemLine>{{ 'global.source' | translate }}: {{document.uploaderInfo | documentUploaderInfoFormatter}}</span>
    </mat-list-option>
    }
  </mat-selection-list>

</form>
}
